<template>
  <div class="summary-panel">
    <vs-loader :visible="!!panelData.isLoading" />
    <chart-summarize
      :title="panelAttr.title"
      :total="panelData.total"
      :prevTotal="panelData.prevTotal"
      :totalFormat="panelAttr.totalFormat"
    >
      <template
        v-if="panelAttr.logo"
        v-slot:logo
      >
        <component :is="panelAttr.logo" />
      </template>
      <template
        v-if="panelAttr.tooltip"
        v-slot:tooltip
      >
        <b-tooltip
          type="is-white"
          size="is-small"
          position="is-bottom"
          :multilined="true"
          :label="panelAttr.tooltip"
        >
          <icon-help />
        </b-tooltip>
      </template>
    </chart-summarize>
    <slot />
  </div>
</template>

<script>
import ChartSummarize from '@/components/dashboard/Chart/chartAndSummary/ChartSummarize'
import CoverageRate from '@/assets/logos/coverage/coverage-rate.svg'
import PageViews from '@/assets/logos/coverage/page-views.svg'
import IconHelp from '@/assets/logos/coverage/icon-help.svg'

export default {
  components: {
    ChartSummarize,
    CoverageRate,
    PageViews,
    IconHelp
  },
  props: {
    panelData: Object, // eslint-disable-line vue/require-default-prop
    panelAttr: Object // eslint-disable-line vue/require-default-prop
  }
}
</script>

<style scoped lang="scss">
.summary-panel {
  position: relative;
  width: 100%;
  padding: 20px;
}

svg {
  margin-right: 5px;
}

.is-white::after {
  padding: 10px;
  border-radius: 2px;
  color: $gray-600 !important;
}
</style>
